<template>
  <div>
    <v-layout align-center>
      <v-flex shrink>
        <div class="title">
          <span class="mr-3">Details</span>
        </div>
      </v-flex>
      <v-spacer/>
      <v-flex shrink>
        <v-btn
          class="ma-0"
          icon
          @click="add">
          <v-icon>add</v-icon>
        </v-btn>
        <v-btn
          v-if="expand === 0 && dtls.length > 0"
          class="ma-0"
          icon
          @click="expand = -1">
          <v-icon>expand_less</v-icon>
        </v-btn>
        <v-btn
          v-else
          :disabled="dtls.length === 0"
          class="ma-0"
          icon
          @click="expand = 0">
          <v-icon>expand_more</v-icon>
        </v-btn>
      </v-flex>
    </v-layout>
    <v-progress-linear
      v-if="deleting"
      class="ma-0"
      color="grey"
      height="1"
      indeterminate/>
    <v-divider v-else/>
    <v-expansion-panel
      v-if="dtls.length > 0"
      :value="expand">
      <v-expansion-panel-content>
        <v-list dense>
          <template v-for="d in dtls">
            <v-list-tile
              :key="d.name"
              avatar>
              <v-list-tile-avatar>
                <v-icon>{{ d.icon }}</v-icon>
              </v-list-tile-avatar>
              <v-list-tile-content>
                <v-list-tile-title>
                  {{ d.value }}
                </v-list-tile-title>
                <v-list-tile-sub-title>
                  {{ d.name }}
                </v-list-tile-sub-title>
              </v-list-tile-content>
              <v-list-tile-action>
                <v-layout justify-center>
                  <v-btn
                    icon
                    class="mx-0"
                    @click="edit(d)">
                    <v-icon>edit</v-icon>
                  </v-btn>
                  <v-btn
                    icon
                    class="mx-0"
                    @click="del(d.id)">
                    <v-icon>delete</v-icon>
                  </v-btn>
                </v-layout>
              </v-list-tile-action>
            </v-list-tile>
          </template>
        </v-list>
      </v-expansion-panel-content>
    </v-expansion-panel>
    <!-- EDIT DIALOG -->
    <v-dialog
      v-model="dialog"
      persistent
      max-width="50rem">
      <v-card>
        <v-card-text>
          <v-form v-model="valid">
            <v-container grid-list-md>
              <v-layout>
                <v-flex>
                  <v-text-field
                    v-model="editedDetail.name"
                    :rules="[v => !!v || 'Name is required']"
                    label="Name"/>
                </v-flex>
              </v-layout>
              <v-layout>
                <v-flex>
                  <v-text-field
                    v-model="editedDetail.value"
                    :rules="[v => !!v || 'Value is required']"
                    label="Value"/>
                </v-flex>
              </v-layout>
              <v-layout>
                <v-flex>
                  <v-autocomplete
                    v-model="editedDetail.icon"
                    :items="materialIcons"
                    :loading="loadingIcons"
                    :rules="[v => !!v || 'Icon is required']"
                    item-text="name"
                    item-value="name"
                    label="Icon">
                    <template
                      slot="item"
                      slot-scope="data">
                      <v-list-tile-content>
                        <v-list-tile-title>
                          {{ data.item.name }}
                        </v-list-tile-title>
                      </v-list-tile-content>
                      <v-list-tile-action-text>
                        <v-icon>{{ data.item.name }}</v-icon>
                      </v-list-tile-action-text>
                    </template>
                  </v-autocomplete>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn
            :disabled="posting"
            flat
            @click="dialog = false">
            Cancel
          </v-btn>
          <v-btn
            :disabled="posting || !valid"
            flat
            @click="save">
            <v-progress-circular
              v-if="posting"
              indeterminate/>
            <span v-else>Save</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "subcontractor-details",
  props: {
    dtls: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      defaultDetail: {
        name: "Address",
        value: "Maddox St, Alexandria",
        icon: "home"
      },
      deleting: false,
      dialog: false,
      editedDetail: {},
      expand: -1,
      insert: true,
      loadingIcons: false,
      materialIcons: [],
      posting: false,
      valid: false
    };
  },
  methods: {
    // When the edition mode is trigerred, open the dialog
    loadIcons () {
      this.loadingIcons = true;
      this.$http.
        get("/api/icons").
        then((r) => this.materialIcons = Array.from(r.data)).
        finally(() => this.loadingIcons = false);
    },
    add () {
      if (this.materialIcons.length === 0) {
        this.loadIcons();
      }
      this.insert = true;
      this.editedDetail = Object.assign(
        {},
        this.defaultDetail,
        { subcontractorId: this.$route.params.id }
      );
      this.dialog = true;
    },
    edit (d) {
      if (this.materialIcons.length === 0) {
        this.loadIcons();
      }
      this.insert = false;
      this.editedDetail = Object.assign({}, d);
      this.dialog = true;
    },
    del (id) {
      if (confirm("Are you sure you want to delete this detail?")) {
        this.deleting = true;
        this.$http.
          delete(`/api/subcontractor_details/${id}`).
          then(() => {
            this.deleting = false;
            this.$emit("refresh");
          }).
          catch(() => this.deleting = false);
      }
    },
    // When the SAVE button of the edition dialog is clicked
    save () {
      if (this.insert) {
        this.posting = true;
        this.$http.
          post("/api/subcontractor_details", this.editedDetail).
          then(() => {
            this.posting = false;
            this.dialog = false;
            this.$emit("refresh");
          }).
          catch(() => this.posting = false);
      } else {
        this.posting = true;
        this.$http.
          put(
            `/api/subcontractor_details/${this.editedDetail.id}`,
            this.editedDetail
          ).
          then(() => {
            this.posting = false;
            this.dialog = false;
            this.$emit("refresh");
          }).
          catch(() => this.posting = false);
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Subcontractor/Details.vue